import { useEffect, useState } from 'react'
import { GetStaticProps, GetStaticPaths } from 'next'
import AnalyticsTrigger from '../../components/atoms/AnalyticsTrigger'
import { NextSeo, ArticleJsonLd } from 'next-seo'
import Layout from '../../components/templates/Layout'
import { convert_date } from '../../functions/datetime/datetime'
import { markup } from '../../functions/markup/markup'
import { async_markup, excute_twitter_widget_script } from '../../functions/markup/async_markup'

const PostDetail = ({post}: {post:any}) => {

  const [postState, setPostState] = useState<any>(post)

  useEffect(() => {
    async_markup(postState.body)
    .then((replacedText) => {
      setPostState({...postState, body: replacedText})
      excute_twitter_widget_script()
    })
  }, [post])

  return (
    <Layout>
      <AnalyticsTrigger title={postState.title} />
      <NextSeo
        title={postState.title + " - デビクレ"}
        description={postState.description}
      />
      <ArticleJsonLd
        url={"https://debicre.com/posts/" + postState.slug}
        title={postState.title}
        images={[]}
        datePublished={(new Date(postState.publish_at)).toISOString()}
        dateModified={(new Date(postState.updated_at)).toISOString()}
        authorName={['Debicre']}
        publisherName="Debicre"
        publisherLogo={"https://debicre.com/" + "static/logos/debicre.png"}
        description={postState.description}
      />
      <div className="card">
        <h1>{postState.title}</h1>
        <div style={{padding: "0 0 16px"}}>
          <small style={{display: "flex", alignItems: "center"}}>
            <span className="material-icons" style={{fontSize: "1.3em", marginRight: "8px"}}>schedule</span>
            <span>{convert_date(postState.publish_at)}</span>
          </small>
        </div>
        <div className="md">
          <div dangerouslySetInnerHTML={{  __html: postState.body}}/>
        </div>
      </div>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  if (context.params) {
    const slug = context.params.slug;
    const res = await fetch(process.env.NEXT_PUBLIC_BACKEND + 'posts/' + slug + '/');
    const json = await res.json();
    const post = json.result
    if (!post || !Object.keys(post).length) {
      return {
        notFound: true,
      }
    }
    post.body = markup(post.body)
    return { props: { post }, revalidate: 10}
  }
  return { notFound: true }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetch(process.env.NEXT_PUBLIC_BACKEND + 'posts/?pagination_count=100');
  const json = await res.json();
  const posts = await json.result
  const paths = posts.map((post: any) => '/posts/' + post.slug);
  return {paths, fallback: 'blocking'}
}

export default PostDetail
